import { render, staticRenderFns } from "./page404.vue?vue&type=template&id=d859f180&"
import script from "./page404.vue?vue&type=script&lang=js&"
export * from "./page404.vue?vue&type=script&lang=js&"
import style0 from "./page404.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports